import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {

  slides = [
    {
      text: 'Texto del Banner',
      desc: 'Este es un mensaje de bienvenida.',
      image: '../../../../assets/images/landing/carousel-1.png',
    },
    {
      text: 'Become a member',
      desc: 'Sign up to Griky and become a member in our learning community.',
      image: '../../../../assets/images/landing/carousel-2.png',
    }
  ];

  current = 0;
  intervalId: any;

  constructor() {}

  ngOnInit(): void {
    this.initSlider();
  }

  initSlider(): void {
    const slideText = document.getElementById('slideText') as HTMLElement;
    const slideImage = document.getElementById('slideImage') as HTMLImageElement;
    const prevBtn = document.getElementById('prev') as HTMLButtonElement;
    const nextBtn = document.getElementById('next') as HTMLButtonElement;

    const showSlide = (index: number) => {
      slideImage.classList.remove('fade-in-image');
      slideImage.classList.add('fade-out-image');

      slideText.classList.remove('fade-in-text');
      slideText.classList.add('fade-out-text');

      setTimeout(() => {
        slideImage.src = this.slides[index].image;
        slideText.innerHTML = `
          <h2 class="text-4xl font-bold drop-shadow-md animated-text">${this.slides[index].text}</h2>
          <p class="text-lg mt-2 drop-shadow-md animated-text">${this.slides[index].desc}</p>
        `;

        void slideImage.offsetWidth;
        void slideText.offsetWidth;

        slideImage.classList.remove('fade-out-image');
        slideImage.classList.add('fade-in-image');

        slideText.classList.remove('fade-out-text');
        slideText.classList.add('fade-in-text');
      }, 400);
    };

    // Mostrar botones si hay más de 1 slide
    if (this.slides.length > 1) {
      prevBtn.classList.remove('hidden');
      nextBtn.classList.remove('hidden');
    }

    // Botones
    prevBtn.addEventListener('click', () => {
      this.current = (this.current - 1 + this.slides.length) % this.slides.length;
      showSlide(this.current);
    });

    nextBtn.addEventListener('click', () => {
      this.current = (this.current + 1) % this.slides.length;
      showSlide(this.current);
    });

    // Auto slide
    this.intervalId = setInterval(() => {
      this.current = (this.current + 1) % this.slides.length;
      showSlide(this.current);
    }, 5000);

    // Animación inicial
    window.addEventListener('load', () => {
      slideText.classList.add('fade-in-text');
      slideImage.classList.add('fade-in-image');
    });
  }
}
